import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormControl, FormGroup, FormsModule, Validators} from '@angular/forms';
import {ChangeEvent, CKEditorModule} from '@ckeditor/ckeditor5-angular';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {SitePublicService} from 'src/app/services/site-public.service';
import {FirebaseUploadAdapter} from 'src/app/shared/adapters/firebase-upload-adapter';
import {AngularFireStorage} from '@angular/fire/compat/storage';
import {Subscription} from 'rxjs';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-conduct',
  templateUrl: './conduct.component.html',
  styleUrls: [ './conduct.component.scss' ]
})
export class ConductComponent implements OnInit, OnDestroy {

  public entityForm: FormGroup;
  public Editor = ClassicEditor;
  public editorData = '';
  public editorConfig: any;

  public htmlContent: string = "";
  private formSubscription: Subscription | undefined;

  public selectedPDF: any;
  public pdfDocument$: any;

  constructor (
    private _sitePublicService: SitePublicService,
    private _dialog: MatDialog,
    private fs: AngularFireStorage,
    private fb: FormBuilder,
    private _snackBar: SnackBarIconService,
    private _spinnerService: SpinnerService,
  ) { }

  ngOnInit (): void {
    this.configEditor()

    const documentKey = 'conduct';
    this.pdfDocument$ = this._sitePublicService.getPDFByKey(documentKey);

    this._sitePublicService.getConduct("conduct_2025")
      .subscribe((result) => {
        this.htmlContent = result

        this.entityForm = this.createForm(this.htmlContent)

        this.formSubscription = this.entityForm.controls.text.valueChanges.subscribe(value => {
          this.htmlContent = value;
        });

      })
  }

  configEditor () {
    // 1. Configuração do Editor (Toolbar e Plugins)
    this.editorConfig = {
      // Toolbar: O que o usuário verá no menu
      toolbar: {
        items: [
          'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|',

          'alignment', '|',

          'indent', 'outdent', '|', 'imageUpload', 'blockQuote', 'insertTable', 'undo', 'redo'
        ]
      },
      alignment: {
        // Define quais opções de alinhamento estarão disponíveis no dropdown
        options: [ 'left', 'right', 'center', 'justify' ]
      },
      // Configuração para o plugin de Link (já habilitado pela toolbar)
      link: {
        decorators: {
          addTargetToExternalLinks: true, // Adiciona target="_blank" para links externos
          defaultProtocol: 'https://'
        }
      },
      // Configuração para imagens (opcional, mas bom para restringir tipos)
      image: {
        toolbar: [
          'imageTextAlternative', 'imageStyle:full', 'imageStyle:side'
        ]
      },
      // Remove a necessidade de ter o CKEditor Cloud Service ou um adaptador padrão
      removePlugins: [ 'Base64UploadAdapter' ]
    };
  }

  ngOnDestroy () {
    // Importante: Desinscreva-se para evitar vazamento de memória
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }
  }

  // 2. Ativa o Adaptador de Upload Personalizado
  public onReady (editor: any) {
    // Adiciona o plugin de upload personalizado (Classe FirebaseUploadAdapter)
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      // CORREÇÃO: Retorna uma NOVA INSTÂNCIA da CLASSE Adaptadora
      return new FirebaseUploadAdapter(loader, this.fs, 'site_pub/conduct/');
    };

    // Agora esta mensagem deve aparecer:
    console.log("CKEditor pronto e adaptador de upload do Firebase ativado.");
  }

  public onChange ({editor}: ChangeEvent) {
    this.editorData = editor.getData();
    // console.log(this.editorData);
  }
  
  createForm (data: any) {

    const form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      position: new FormControl(data.position, [ Validators.required ]),
      date: new FormControl(data.date?.toDate() || null, [ Validators.required ]),
      title: new FormControl(data.title, [ Validators.required ]),
      text: new FormControl(data.text, [ Validators.required ])
    });

    this.htmlContent = data.text;

    return form
  }

  saveData () {
    const formData = this.entityForm.getRawValue();
    const entity = {
      "id": 'conduct_2025',
      "position": 1,
      "date": new Date(),
      "title": 'Código de Conduta',
      "text": formData.text
    }

    console.log(JSON.stringify(entity));

    this._sitePublicService.setConduct(entity)
      .then(() => {
        this._snackBar.openSnackBar("Sucesso", '', 'success');
      })
      .catch((err) => {
        this._snackBar.openSnackBar("Erro", '', 'error');
      })
  }

  pdfChange (data: any) {
    const file: File = data.target.files[ 0 ]
    this.selectedPDF = file
    console.log(this.selectedPDF.name);


  }

  async savePDF () {
    const file: File = this.selectedPDF;
    const key: string = 'conduct'

    try {
      const url = await this._sitePublicService.uploadPDF(file, key, "pub_pdfs");
      console.log("Upload e registro concluídos. URL:", url);
      // Faça algo com a URL (ex: atualizar o formulário, exibir sucesso)
    } catch (error) {
      console.error("Erro durante o processo de upload/registro:", error);
      // Trate o erro (ex: exibir mensagem para o usuário)
    }
  }

  openDeletePDF (documentKey: string) {
    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: "<br><br>Deseja excluir este pPDF?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this.deletePDF(documentKey)
      }
    })

  }

  async deletePDF (documentKey: string) {
    const waiting = this._spinnerService.show();

    try {
      // Chama a função e aguarda a conclusão da exclusão do Firestore e do Storage
      await this._sitePublicService.deletePDF('pub_pdfs', documentKey);

      // Exibe feedback de sucesso e atualiza a interface (ex: recarrega a lista)
      console.log(`Registro e arquivo deletados com sucesso: ${ documentKey }`);
      //this.loadStatute(); // Exemplo: recarrega os dados na tabela

    } catch (error) {
      console.error("Não foi possível completar a exclusão:", error);
      // Exibir mensagem de erro para o usuário
    } finally {
      waiting.close();
    }
  }

}
